import { render, staticRenderFns } from "./CustomRoleDetailsAdmin.vue?vue&type=template&id=edb3c1ae&"
import script from "./CustomRoleDetailsAdmin.vue?vue&type=script&lang=js&"
export * from "./CustomRoleDetailsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports